module.exports = __webpack_public_path__ + "static/media/system.604c46ff.jpeg";